export const news = [
  {
    id: "news-01",
    title: "徐允儿主持年度媒体峰会，沉稳主持获业界一致好评",
    summary: "徐允儿受邀担任年度媒体峰会主论坛主持人，与多位行业领袖对话，展现深厚的临场功底与专业素养。",
    date: "2026-10-15",
    cover: "https://readdy.ai/api/search-image?query=broadcast%20conference%20stage%20with%20Korean%20female%20anchor%20hosting%20panel%20discussion%2C%20warm%20stage%20lights%2C%20modern%20convention%20set%2C%20editorial%20photography&width=600&height=400&seq=news-01&orientation=landscape",
    streamerId: "seo-yuna",
    streamerName: "徐允儿",
    category: "新闻",
  },
  {
    id: "news-02",
    title: "林世拉独家专访顶流偶像，节目片段播放量破千万",
    summary: "林世拉在《首尔娱乐快报》中的一场深度专访引发热议，真诚的提问让受访嘉宾罕见吐露心声。",
    date: "2026-10-15",
    cover: "https://readdy.ai/api/search-image?query=Korean%20female%20entertainment%20host%20interviewing%20idol%20guest%20in%20bright%20studio%2C%20warm%20lights%2C%20modern%20talk%20set%2C%20editorial%20photography&width=600&height=400&seq=news-02&orientation=landscape",
    streamerId: "im-sera",
    streamerName: "林世拉",
    category: "娱乐",
  },
  {
    id: "news-03",
    title: "韩诗雅回归《音乐银行》舞台，秋季特别企划公开",
    summary: "韩诗雅将主持《音乐银行》秋季特别企划，节目组透露将有多组顶级艺人同台，粉丝期待值拉满。",
    date: "2026-10-15",
    cover: "https://readdy.ai/api/search-image?query=colorful%20Korean%20music%20chart%20show%20stage%20with%20female%20host%20and%20glowing%20lights%2C%20vibrant%20set%2C%20editorial%20photography&width=600&height=400&seq=news-03&orientation=landscape",
    streamerId: "han-sia",
    streamerName: "韩诗雅",
    category: "娱乐",
  },
  {
    id: "news-04",
    title: "郑多恩新综艺首播夺冠，收视率创周末档新高",
    summary: "郑多恩领衔的《周末综艺秀》全新一季首播即夺得同档期收视第一，生动活泼的主持风格受到观众喜爱。",
    date: "2026-10-14",
    cover: "https://readdy.ai/api/search-image?query=lively%20Korean%20weekend%20variety%20show%20stage%20with%20female%20host%20laughing%2C%20warm%20studio%20lights%2C%20editorial%20photography&width=600&height=400&seq=news-04&orientation=landscape",
    streamerId: "jung-daeun",
    streamerName: "郑多恩",
    category: "综艺",
  },
  {
    id: "news-05",
    title: "白智雅现身首尔时装周，前排造型成全场焦点",
    summary: "白智雅受邀出席首尔时装周大秀，她以简约高级的造型亮相前排，成为媒体镜头追逐的焦点。",
    date: "2026-10-14",
    cover: "https://readdy.ai/api/search-image?query=elegant%20Seoul%20fashion%20week%20runway%20with%20Korean%20female%20host%20in%20front%20row%2C%20warm%20spotlights%2C%20luxury%20set%2C%20editorial%20photography&width=600&height=400&seq=news-05&orientation=landscape",
    streamerId: "baek-jia",
    streamerName: "白智雅",
    category: "娱乐",
  },
  {
    id: "news-06",
    title: "金荷娜脱口秀百期特辑，金句合辑再度刷屏",
    summary: "《深夜脱口秀》迎来百期特辑，金荷娜在节目中回顾经典瞬间，多段表现片段登上社交平台热搜。",
    date: "2026-10-13",
    cover: "https://readdy.ai/api/search-image?query=cozy%20late%20night%20talk%20show%20set%20with%20Korean%20female%20host%20and%20guest%20sofa%2C%20warm%20ambient%20lights%2C%20editorial%20photography&width=600&height=400&seq=news-06&orientation=landscape",
    streamerId: "kim-hana",
    streamerName: "金荷娜",
    category: "综艺",
  },
  {
    id: "news-07",
    title: "姜智秀清晨新闻改版升级，加入全新生活板块",
    summary: "KBS 清晨新闻宣布改版，姜智秀将继续担任主播，并带来全新生活资讯板块，为观众开启元气早晨。",
    date: "2026-10-13",
    cover: "https://readdy.ai/api/search-image?query=bright%20morning%20news%20studio%20with%20Korean%20female%20anchor%20at%20desk%2C%20soft%20window%20light%2C%20minimal%20set%2C%20editorial%20photography&width=600&height=400&seq=news-07&orientation=landscape",
    streamerId: "kang-jisu",
    streamerName: "姜智秀",
    category: "新闻",
  },
  {
    id: "news-08",
    title: "吴世恩独家报道娱乐公司合约风波，引发行业讨论",
    summary: "吴世恩的一线报道揭开娱乐公司合约纠纷内幕，专业克制的采访获得同行与网友的双重认可。",
    date: "2026-10-14",
    cover: "https://readdy.ai/api/search-image?query=Korean%20female%20reporter%20covering%20entertainment%20news%20at%20press%20event%2C%20warm%20lights%2C%20urban%20backdrop%2C%20editorial%20photography&width=600&height=400&seq=news-08&orientation=landscape",
    streamerId: "oh-seeun",
    streamerName: "吴世恩",
    category: "娱乐",
  },
  {
    id: "news-09",
    title: "崔秀彬财经论坛开讲，深度解析年度经济趋势",
    summary: "崔秀彬在年度财经论坛中担任主讲，结合数据与案例解析市场走势，被观众评价为最易懂的财经解读。",
    date: "2026-10-11",
    cover: "https://readdy.ai/api/search-image?query=modern%20financial%20forum%20stage%20with%20Korean%20female%20anchor%20and%20market%20charts%2C%20cool%20lighting%2C%20sleek%20set%2C%20editorial%20photography&width=600&height=400&seq=news-09&orientation=landscape",
    streamerId: "choi-subin",
    streamerName: "崔秀彬",
    category: "新闻",
  },
  {
    id: "news-10",
    title: "尹彩英新人综艺斩获新星奖，未来可期",
    summary: "出道仅两年的尹彩英凭借自然清新的表现斩获年度新星奖，她在领奖台上感谢一路支持的观众。",
    date: "2026-10-10",
    cover: "https://readdy.ai/api/search-image?query=cheerful%20Korean%20rookie%20host%20receiving%20award%20on%20stage%2C%20warm%20colorful%20lights%2C%20festive%20set%2C%20editorial%20photography&width=600&height=400&seq=news-10&orientation=landscape",
    streamerId: "yoon-chaeyoung",
    streamerName: "尹彩英",
    category: "综艺",
  },
];